export const COL_NAMES = {
    clientCoupons: "clientCoupons",
    clients: "clients",
    coupons: "coupons",
    cmsUsers: 'cmsUsers'
};